import React from 'react';
interface HoverTooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  align?: 'left' | 'right';
  className?: string;
}

// Small dark tooltip shown on hover or keyboard focus of its trigger
export function HoverTooltip({
  content,
  children,
  align = 'left',
  className = ''
}: HoverTooltipProps) {
  return <span tabIndex={0} className={`relative inline-flex group focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0EA5E9]/30 rounded ${className}`} data-id="element-1567" data-mp="1vphb4owm7x2c">
      {children}
      <span role="tooltip" className={`pointer-events-none absolute top-full mt-2 z-20 hidden group-hover:block group-focus:block min-w-[220px] max-w-[320px] bg-[#0F172A] text-white text-[12px] font-normal normal-case tracking-normal leading-relaxed rounded-md px-3 py-2 shadow-md ${align === 'right' ? 'right-0' : 'left-0'}`} data-id="element-1568" data-mp="1313dwbdcp4ru">
        {content}
      </span>
    </span>;
}